// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import { Box, Button, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Thumbs } from 'swiper/modules';
import { styled } from '@mui/material/styles';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const StyledSwiper = styled(Swiper)(({
  theme, styles,
}) => ({
  width: '100%',
  height: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  '.swiper-slide-thumb-active': {
    opacity: '1',
  },
  ...styles,
}));

const StyledSwiperSlide = styled(SwiperSlide)(({
  theme, styles,
}) => ({
  textAlign: 'center',
  fontSize: '18px',
  background: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ...styles,
}));

const StyledSliderImage = styled('img')(({
  theme, styles,
}) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  ...styles,
}));

export default function ImageGallery(props) {
  const { images, imageThumbnails } = props;
  const theme = useTheme();
  const [swiper, setSwiper] = useState();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const handleGoToPreviousPageSwiper = () => {
    swiper?.slidePrev();
  };
  const handleGoToNextPageSwiper = () => {
    swiper?.slideNext();
  };

  const handleGoToPreviousPageThumbs = () => {
    thumbsSwiper?.slidePrev();
  };
  const handleGoToNextPageThumbs = () => {
    thumbsSwiper?.slideNext();
  };

  return (
    <>
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <Button
          aria-label="previous"
          onClick={handleGoToPreviousPageSwiper}
          size="small"
          sx={{
            position: 'absolute',
            width: 40,
            height: 40,
            minWidth: 0,
            top: '45%',
            bottom: 30,
            left: 10,
            zIndex: 999,
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}
        >
          <FiChevronLeft
            style={{
              color: 'white',
              width: 15,
              height: 15,
            }}
          />
        </Button>
        <StyledSwiper
          loop
          modules={[FreeMode, Thumbs]}
          onSwiper={setSwiper}
          spaceBetween={10}
          style={{
            '--swiper-navigation-color': '#fff',
            '--swiper-pagination-color': '#fff',
            height: '80%',
            width: '100%',
          }}
          thumbs={{ swiper: thumbsSwiper }}
        >
          {images.map((image) => (
            <StyledSwiperSlide key={image}>
              <StyledSliderImage alt={image} src={image} />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
        <Button
          aria-label="next"
          onClick={handleGoToNextPageSwiper}
          size="small"
          sx={{
            position: 'absolute',
            width: 40,
            height: 40,
            minWidth: 0,
            top: '45%',
            bottom: 30,
            right: 10,
            zIndex: 999,
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}
        >
          <FiChevronRight
            style={{
              color: 'white',
              width: 15,
              height: 15,
            }}
          />
        </Button>
      </Box>
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <Button
          aria-label="previous"
          onClick={handleGoToPreviousPageThumbs}
          size="small"
          sx={{
            position: 'absolute',
            width: 30,
            height: 30,
            minWidth: 0,
            top: '40%',
            bottom: 30,
            left: 10,
            zIndex: 999,
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
        >
          <FiChevronLeft
            style={{
              color: 'white',
              width: 10,
              height: 10,
            }}
          />
        </Button>
        <StyledSwiper
          freeMode
          loop
          modules={[FreeMode, Thumbs]}
          onSwiper={setThumbsSwiper}
          slidesPerView={5}
          spaceBetween={10}
          style={{
            height: '20%',
            boxSizing: 'border-box',
            padding: '10px 0',
            '.swiper-slide-thumb-active': {
              opacity: '1',
            },
          }}
          watchSlidesProgress
        >
          {imageThumbnails.map((imageThumbnail) => (
            <StyledSwiperSlide
              key={imageThumbnail}
              styles={{
                width: '20%',
                height: '100%',
                opacity: '0.4',
              }}
            >
              <StyledSliderImage alt={imageThumbnail} src={imageThumbnail} />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
        <Button
          aria-label="next"
          onClick={handleGoToNextPageThumbs}
          size="small"
          sx={{
            position: 'absolute',
            width: 30,
            height: 30,
            minWidth: 0,
            top: '40%',
            bottom: 30,
            right: 10,
            zIndex: 999,
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
        >
          <FiChevronRight
            style={{
              color: 'white',
              width: 10,
              height: 10,
            }}
          />
        </Button>
      </Box>
    </>
  );
}
